import React from "react";

import { SubTitleText } from "./styles";

interface Props {
  text: string;
  fontSize?: string;
  margin?: string;
}

export const SubTitle = ({ text, fontSize, margin }: Props) => {
  return (
    <SubTitleText size={fontSize} margin={margin}>
      {text}
    </SubTitleText>
  );
};
